import React from "react";
import { useNavigate } from "react-router-dom";
import HeroImage from "../../assets/images/hero-image.png";
import HeroImageSmall from "../../assets/images/hero-image_low.webp";
import CustomButton from "../Form/CustomButton";
import { useBlurredImageLoader } from "../../utils/useBlurredImageLoader";

const HeroSection = () => {
  const navigate = useNavigate();
  const { containerRefs, imgRefs } = useBlurredImageLoader(2);
  const [mobileContainerRef, desktopContainerRef] = containerRefs;
  const [mobileImgRef, desktopImgRef] = imgRefs;

  const handleLearnMoreClick = () => {
    navigate("/life-at-roselea");
  };

  const handleContactUsClick = () => {
    navigate("/contact-us");
  };

  return (
    <>
      {/* Mobile View: Text then Image */}
      <div className="block sm:hidden px-6 py-10 font-poppins text-green">
        <div className="mb-8 ">
          <h1 className="text-[28px] font-bold leading-tight mb-6">
            Care You Can Trust, Comfort They Deserve
          </h1>
          <p className="text-[14px] lg:text-[20px] xl:text-[23px] mb-10 sm:mb-14 leading-relaxed">
            Because your loved ones deserve the best. At Roselea, we offer personalised care that respects independence while ensuring safety, comfort, and peace of mind, every step of the way.
          </p>
          <div className="flex flex-row gap-4 justify-start">
            <CustomButton
              bgColor="bg-[var(--primary-orange-color)]"
              buttonText="Learn More"
              width="w-36"
              textColor="text-white"
              textWeight="font-semibold"
              onClick={handleLearnMoreClick}
            />
            <CustomButton
              bgColor="bg-transparent"
              borderColor="border-[var(--primary-orange-color)]"
              buttonText="Contact Us"
              width="w-36"
              textColor="text-[var(--primary-orange-color)]"
              onClick={handleContactUsClick}
            />
          </div>
        </div>
        <div 
          ref={mobileContainerRef}
          className="blurred-img w-full rounded-xl overflow-hidden"
          style={{ backgroundImage: `url(${HeroImageSmall})` }}
        >
          <img
            ref={mobileImgRef}
            src={HeroImage}
            alt="Hero"
            className="w-full rounded-xl object-cover"
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />
        </div>
      </div>

      {/* Tablet and Larger View: Background Image with Overlay */}
      <div className="hidden sm:block relative w-full min-h-[500px] sm:min-h-[600px] lg:min-h-[700px] z-10 overflow-hidden -mb-[80px]">
        {/* Background Image with Blur Effect */}
        <div 
          ref={desktopContainerRef}
          className="blurred-img absolute inset-0 w-full h-full"
          style={{ backgroundImage: `url(${HeroImageSmall})` }}
        >
          <img
            ref={desktopImgRef}
            src={HeroImage}
            alt="Hero"
            className="w-full h-full object-cover object-center sm:object-fit"
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />
        </div>

        {/* Overlay Content */}
        <div className="absolute inset-0 z-20 px-10 xl:px-0 max-w-7xl mx-auto flex flex-col items-start justify-center font-poppins text-green">
          <div className="max-w-full sm:max-w-sm lg:max-w-xl xl:max-w-2xl ">
            <h1 className="text-[28px] lg:text-[42px] xl:text-[60px] font-bold leading-tight mb-4">
              Care You Can Trust, Comfort They Deserve
            </h1>
            <p className="text-[14px] lg:text-[20px] xl:text-[23px] mb-10 leading-relaxed">
              Because your loved ones deserve the best. At Roselea, we offer personalised care that respects independence while ensuring safety, comfort, and peace of mind, every step of the way.
            </p>
            <div className="flex flex-row gap-4 justify-start">
              <CustomButton
                bgColor="bg-[var(--primary-orange-color)]"
                buttonText="Learn More"
                width="w-36"
                textColor="text-white"
                textWeight="font-semibold"
                className={"hover:bg-[var(--hover-orange-color)]"}
                onClick={handleLearnMoreClick}
              />
              <CustomButton
                bgColor="bg-transparent"
                borderColor="border-[var(--primary-orange-color)]"
                buttonText="Contact Us"
                width="w-36"
                textColor="text-[var(--primary-orange-color)]"
                className={"hover:bg-[#F6867A0D]"}
                onClick={handleContactUsClick}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
